import { Popover, PopoverContent, PopoverTrigger } from '@massilia/ui'
import { HelpCircle, Tag } from 'lucide-react'

/** ALLOT-PROMO : badge des offres au tarif d'allotement, rouge sur rouge clair en haut de
 * la carte, avec une bulle d'aide au clic comme « Détail des prix ». */
export function PromotionBadge() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="inline-flex cursor-pointer items-center gap-1 rounded border border-red-200 bg-red-50 px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-red-700 uppercase transition-colors hover:bg-red-100 lg:text-[11px]"
          type="button"
        >
          <Tag aria-hidden className="size-3" />
          Promotion
          <HelpCircle aria-hidden className="size-3" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="w-auto max-w-xs border border-red-200 bg-red-50 p-3 text-sm text-red-700 shadow-lg"
        side="top"
        sideOffset={6}
      >
        Offre à durée limitée
      </PopoverContent>
    </Popover>
  )
}
